export const getAttachmentDriverFileEndpoint = '/berths/booking/driver-attachment' as const
